import(/* webpackMode: "eager" */ "/home/ubuntu/download/695949517683ed0014eb4b27/signaly_trading_platform/node_modules/next/dist/client/components/app-router.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/695949517683ed0014eb4b27/signaly_trading_platform/node_modules/next/dist/client/components/client-page.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/695949517683ed0014eb4b27/signaly_trading_platform/node_modules/next/dist/client/components/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/695949517683ed0014eb4b27/signaly_trading_platform/node_modules/next/dist/client/components/layout-router.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/695949517683ed0014eb4b27/signaly_trading_platform/node_modules/next/dist/client/components/not-found-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/695949517683ed0014eb4b27/signaly_trading_platform/node_modules/next/dist/client/components/render-from-template-context.js");
